<div class="shell" [class.shell--nav-open]="navOpen">
    <app-sidebar
        class="shell__sidebar"
        [branding]="branding"
        [navigation]="navigation"
        [account]="account"
        [currentUrl]="currentUrl"
        [loading]="loading"
        [languages]="languages"
        [currentLanguage]="currentLanguage"
        [freeTrialDaysLeft]="freeTrialDaysLeft"
        [showPoweredBy]="showPoweredBy"
        [controlling]="controlledOrganization !== null"
        (stopControlling)="stopControlling.emit()"
        (navigate)="closeNav()"
        (languageChange)="languageChange.emit($event)"
        (logout)="logout.emit()"
        (contactSales)="contactSales.emit()" />

    @if (navOpen) {
        <button
            type="button"
            class="shell__mask"
            tabindex="-1"
            [attr.aria-label]="'menu.shell.closeMenu' | translate"
            (click)="closeNav()"></button>
    }

    <div class="shell__main">
        <app-mobile-topbar
            class="shell__topbar"
            [logo]="branding.logo"
            [menuOpen]="navOpen"
            (menuToggle)="toggleNav()" />
        <main class="shell__content">
            <ng-content />
        </main>
    </div>
</div>
